export default function decodeEntities (str) {
	const mimeType = 'text/html';
	const parser = new DOMParser().parseFromString(str, mimeType);

	return parser.documentElement.textContent;
};
